import { useState, MouseEvent } from "react";
import { Box, Typography, Menu, MenuItem, Button } from "@mui/material";
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";

export enum ExceptionsView {
  List = "List",
  AuditLog = "Audit Log",
}

interface Props {
  selectedView: ExceptionsView;
  onViewChange: (view: ExceptionsView) => void;
}

export function ExceptionsViewSwitcher({ selectedView, onViewChange }: Props) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelectView = (newView: ExceptionsView) => {
    onViewChange(newView);
    handleClose();
  };

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="flex-end"
        sx={{ mb: 4, mt: 3 }}
      >
        <Typography variant="body1" color="text.secondary">
          Exceptions view
        </Typography>
        <Button
          onClick={handleClick}
          endIcon={<ExpandMoreIcon sx={{ color: "primary.light" }} />}
          sx={{
            ml: 0.5,
            my: -1,
            textTransform: "none",
            fontWeight: "700",
            fontSize: 16,
          }}
        >
          {selectedView}
        </Button>
      </Box>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem
          onClick={() => handleSelectView(ExceptionsView.List)}
          selected={selectedView === ExceptionsView.List}
        >
          List
        </MenuItem>
        <MenuItem
          onClick={() => handleSelectView(ExceptionsView.AuditLog)}
          selected={selectedView === ExceptionsView.AuditLog}
        >
          Audit Log
        </MenuItem>
      </Menu>
    </>
  );
}
